import {
  SHIFT_CONDITION_LIST, SHIFT_CONDITION_LIST_SUCCESS, SHIFT_CONDITION_LIST_FAILURE,
  SHIFT_CONDITION_DELETE, SHIFT_CONDITION_DELETE_SUCCESS, SHIFT_CONDITION_DELETE_FAILURE,
  SHIFT_CONDITION_EDIT, SHIFT_CONDITION_EDIT_SUCCESS, SHIFT_CONDITION_EDIT_FAILURE,
  SHIFT_CONDITION_UPDATE, SHIFT_CONDITION_UPDATE_SUCCESS, SHIFT_CONDITION_UPDATE_FAILURE
} from './mutation-types'

export default {
  state: {
    shiftConditionUsers: [],
    shiftClasses: [],
    shiftConditionEdit: [],
    shiftClassesAll: [],
    shiftConditionUser: []
  },
  getters: {
    shiftConditionUsers: state => {
      return state.shiftConditionUsers
    },
    shiftClasses: state => {
      return state.shiftClasses
    },
    shiftConditionEdit: state => {
      return state.shiftConditionEdit
    },
    shiftClassesAll: state => {
      return state.shiftClassesAll
    },
    shiftConditionUser: state => {
      return state.shiftConditionUser
    }
  },
  actions: {
    [SHIFT_CONDITION_LIST] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiGet', {url: '/master/shift_conditions', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CONDITION_LIST_FAILURE, res.data)
          } else {
            commit(SHIFT_CONDITION_LIST_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHIFT_CONDITION_DELETE] ({dispatch, state, commit}, params) {
      var data = params.data
      dispatch('apiDelete', {url: '/master/shift_conditions/' + data.user_id, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CONDITION_DELETE_FAILURE, res.data)
          } else {
            commit(SHIFT_CONDITION_DELETE_SUCCESS, { data: res.data, callback: params.callback })
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHIFT_CONDITION_EDIT] ({dispatch, state, commit}, params = null) {
      var url = '/master/shift_conditions/' + params.id + '/edit'
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CONDITION_EDIT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(SHIFT_CONDITION_EDIT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHIFT_CONDITION_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/master/shift_conditions/' + params.user_id, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CONDITION_UPDATE_FAILURE, res.data)
          } else {
            commit(SHIFT_CONDITION_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHIFT_CONDITION_LIST_FAILURE] (state, data) {
      console.log('SHIFT_CONDITION_LIST_FAILURE')
    },
    [SHIFT_CONDITION_LIST_SUCCESS] (state, data) {
      console.log('SHIFT_CONDITION_LIST_SUCCESS')
      state.shiftConditionUsers = data.data.shift_conditions
      state.shiftClasses = data.data.shift_classes
      if (data.callback) {
        data.callback()
      }
    },
    [SHIFT_CONDITION_DELETE_FAILURE] (state, data) {
      console.log('SHIFT_CONDITION_DELETE_FAILURE')
    },
    [SHIFT_CONDITION_DELETE_SUCCESS] (state, data) {
      console.log('SHIFT_CONDITION_DELETE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    },
    [SHIFT_CONDITION_EDIT_FAILURE] (state, data) {
      console.log('SHIFT_CONDITION_EDIT_FAILURE')
    },
    [SHIFT_CONDITION_EDIT_SUCCESS] (state, data) {
      console.log('SHIFT_CONDITION_EDIT_SUCCESS')
      state.shiftClassesAll = data.shift_classes.data
      state.shiftConditionEdit = data.shift_condition
      state.shiftConditionUser = data.shift_user
      if (data.callback) {
        data.callback()
      }
    },
    [SHIFT_CONDITION_UPDATE_FAILURE] (state, data) {
      console.log('SHIFT_CONDITION_UPDATE_FAILURE')
    },
    [SHIFT_CONDITION_UPDATE_SUCCESS] (state, data) {
      console.log('SHIFT_CONDITION_UPDATE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shift-condition.js